<template>
  <div class="success-content">
    <font-awesome-icon class="success-icon" :icon="'thumbs-up'" />
    <h1 class="success-title">Seu boleto bancário foi emitido com sucesso!</h1>

    <p class="success-text">Clique no botão abaixo para visualizar o boleto.</p>

    <a :href="billet" class="button" role="button"><span>Baixar o boleto bancário</span></a>

    <div v-if="!valid">
      <p class="success-text">
        Acesse a Área do Cliente em nosso site
        <a target="_blank" href="https://valesaudepet.com.br" title="Vale Saúde Pet"
          >valesaudepet.com.br</a
        >.
        <br />
        Clique em PRIMEIRO ACESSO e digite seu e-mail cadastrado.<br />
        Você receberá um e-mail para definir sua senha
      </p>

      <!-- Retornar botões assim que tivermos o app publicado -->
      <p class="success-buttons" v-if="false">
        <!-- TODO: Alterar URL do app para Vale Saúde Pet -->
        <a href="https://apps.apple.com/br/app/vale-sa%C3%BAde-sempre/id1473828335" target="black">
          <img
            src="../../../public/img/download/apple-store.png"
            alt="vale saude pet app"
            title="app da vale saude pet"
          />
        </a>
        <!-- TODO: Alterar URL do app para Vale Saúde Pet -->
        <a
          href="https://play.google.com/store/apps/details?id=cliente.valesaudesempre.com.br&hl=pt_BR"
          target="black"
        >
          <img
            src="../../../public/img/download/google-app.png"
            alt="vale saude pet app"
            title="app da vale saude pet"
          />
        </a>
      </p>

      <p class="success-text">
        <strong>Para cadastrar seus pets, acesse a Área do Cliente.</strong>
      </p>
    </div>

    <div v-else>
      <Instructions />
    </div>
  </div>
</template>

<script>
import { isAlelo } from '@/utils/alelo';
import Instructions from '@/components/utils/Instructions.vue';

export default {
  name: 'SuccessDefault',
  components: { Instructions },
  data() {
    return {
      message: sessionStorage.getItem('paid'),
      billet: sessionStorage.getItem('bankslipUrl')
    };
  },
  mounted() {
    if (!sessionStorage.getItem('paid')) {
      this.$router.push({
        name: 'register'
      });
    }
  },
  computed: {
    valid() {
      return isAlelo(this.$route);
    }
  }
};
</script>
